import { createSlice } from '@reduxjs/toolkit';

const vehiclesSlice = createSlice({
  name: 'vehicles',
  initialState: {
    // Map de vehicle_id → données en temps réel
    live: {},
    selectedId: null,
  },
  reducers: {
    vehicleUpdated: (state, action) => {
      const d = action.payload;
      state.live[d.vehicle_id] = {
        ...state.live[d.vehicle_id],
        ...d,
        lastUpdate: Date.now(),
      };
    },
    vehicleDisconnected: (state, action) => {
      const id = action.payload;
      if (state.live[id]) {
        state.live[id].status = 'inactive';
      }
    },
    selectVehicle: (state, action) => {
      state.selectedId = action.payload;
    },
    clearStale: (state) => {
      const now = Date.now();
      Object.keys(state.live).forEach((id) => {
        if (now - state.live[id].lastUpdate > 60000) {
          state.live[id].status = 'inactive';
        }
      });
    },
  },
});

export const { vehicleUpdated, vehicleDisconnected, selectVehicle, clearStale } = vehiclesSlice.actions;
export default vehiclesSlice.reducer;
